// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","385":"component---src-templates-using-dsg-js"}[chunkId] + "-" + {"125":"e81df73a9ed30b9be6c5","223":"899f88dfb7382038a66f","293":"53977d813bb24083850f","385":"4f837dcb197342f4c554"}[chunkId] + ".js";
};